// Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Components
import { AccessComponent } from './access.component';

const routes: Routes = [
    {
        path: 'login/:lang',
        component: AccessComponent,
        runGuardsAndResolvers: 'always',
        data: {
            bodyClass: 'min-h-screen',
        },
    },
    {
        path: 'login',
        component: AccessComponent,
        runGuardsAndResolvers: 'always',
        data: {
            title: 'Grupo Soledad B2B | Distribución de neumático profesional. Login',
            description: 'Grupo Soledad B2B | Distribución de neumático profesional. Login',
            bodyClass: 'min-h-screen',
        },
    },
    {
        path: 'signup',
        component: AccessComponent,
        data: {
            title: 'Grupo Soledad B2B | Distribución de neumático profesional. Registro',
            description: 'Grupo Soledad B2B | Distribución de neumático profesional. Registro',
            bodyClass: 'min-h-screen',
        },
    },
    {
        path: 'remember',
        component: AccessComponent,
        data: {
            title: 'Grupo Soledad B2B | Recordar contraseña',
            description: 'Grupo Soledad B2B | Recordar contraseña',
            bodyClass: 'min-h-screen',
        },
    },
    {
        path: 'reset/:token',
        component: AccessComponent,
        data: {
            bodyClass: 'min-h-screen',
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AccessRoutesModule {}
